import gql from 'graphql-tag';
export default gql`
  mutation createClonedOpportunity($opportunityId: String!) {
    createClonedOpportunity(opportunityId: $opportunityId)
  }
`;
